import { QueryClient, queryOptions } from "@tanstack/react-query"
import { get_user, USER_QUERY_KEY } from "./index"
import { getAllFinancialModelsQuery } from "@/feature/financial-model/api"
import { useAppConfigStore } from "@/feature/auth/store/app-config"

import { tryCatch } from "@/lib/utils/try-catch"
import { removeAuthTokens } from "@/api/axios"
import { useFinancialModelSettingsStore } from "@/feature/financial-model/settings/store/financialModelSettingsStore"
import { adaptFinancialModelToStore } from "@/feature/financial-model/settings/utils/normalizeSettingsStore"
import { getFullSettingsQueryOptions } from "@/feature/settings/api"

const getUserDeatilsQuery = queryOptions({
  queryKey: USER_QUERY_KEY,
  queryFn: get_user,
})

export const bootstrapLoader = (queryClient: QueryClient) => async () => {
  // App config should already be loaded by useBootstapAppConfigQuery, but handle case where it's not
  const { appConfig } = useAppConfigStore.getState()

  const [user, userError] = await tryCatch(
    queryClient.ensureQueryData(getUserDeatilsQuery)
  )
  if (userError) {
    removeAuthTokens()
    window.location.href = `/auth/login`
    return null
  }
  if (user.status === `pending`) {
    localStorage.setItem(`sign_up_mail`, user.email)
    removeAuthTokens()
    window.location.href = `/auth/resend`
    return null
  }
  const [settings, settingsError] = await tryCatch(
    queryClient.ensureQueryData(getFullSettingsQueryOptions)
  )
  if (settingsError) {
    return null
  }

  if (!settings.workspace || !settings.organization || !settings.company) {
    return null
  }
  const allFinancialModels = await queryClient.ensureQueryData(
    getAllFinancialModelsQuery()
  )
  if (allFinancialModels.length > 0) {
    for (const financialModel of allFinancialModels) {
      useFinancialModelSettingsStore
        .getState()
        .setModelSettings(
          financialModel.financialModel.id,
          adaptFinancialModelToStore(financialModel.financialModel)
        )
    }
  }

  return { user, settings, appConfig }
}
export type BootstrapLoaderResponse = Awaited<
  ReturnType<ReturnType<typeof bootstrapLoader>>
>
